import ApplyInsurance from "../../../Pages/Insurance";

import { modalVariants } from "../../../Utils/constants";

export default function renderApplyInsurance(modalContext) {
  const { updateModalComponent, setModalClassName, setModalVariant, setModalAriaLabel } = modalContext;

  updateModalComponent(ApplyInsurance);
  setModalVariant(modalVariants.fullScreenDialog);
  setModalClassName("apply-insurance hide-header");
  setModalAriaLabel?.("Apply for renters insurance");
}
